/**
 * Lightweight arrow-button carousel for the Featured Products / workbook
 * list block. Query-based (not a custom element) since the block's own
 * wrapper tag name is dynamically generated per instance
 * (workbook-list-<id>) and can't be pre-registered as a custom element.
 *
 * Scrolls the existing horizontally-scrollable track by one card width
 * per click; the prev/next buttons disable themselves at the start/end
 * and hide entirely (via CSS :disabled) when there's nothing to scroll.
 */
function initWorkbookCarousel(root) {
  const track = root.querySelector('[data-workbook-track]');
  const prevBtn = root.querySelector('[data-workbook-prev]');
  const nextBtn = root.querySelector('[data-workbook-next]');
  if (!(track instanceof HTMLElement) || !(prevBtn instanceof HTMLButtonElement) || !(nextBtn instanceof HTMLButtonElement)) {
    return;
  }

  const updateArrows = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
  };

  const scrollByOneCard = (direction) => {
    const card = track.firstElementChild;
    const cardWidth = card instanceof HTMLElement ? card.getBoundingClientRect().width : track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  };

  prevBtn.addEventListener('click', () => scrollByOneCard(-1));
  nextBtn.addEventListener('click', () => scrollByOneCard(1));
  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);

  updateArrows();
}

document.querySelectorAll('[data-workbook-carousel]').forEach(initWorkbookCarousel);
